import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import CircularProgress from '@mui/material/CircularProgress'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import { type PaymentOrderV2, PaymentOrderV2StateEnum } from '@mynt/backoffice-api-spec/payment'
import type React from 'react'
import { useMarkPaymentOrderAmlApproved } from '../../api/react-query'

type ActionItemProps = {
  paymentOrder: PaymentOrderV2
  onSuccess: () => unknown
}

type ActionMenuItem = {
  ({ paymentOrder, onSuccess }: ActionItemProps): React.ReactElement
  disabled: (paymentOrder: PaymentOrderV2) => boolean
}

const AML_APPROVABLE_STATES: PaymentOrderV2StateEnum[] = [
  PaymentOrderV2StateEnum.REQUESTED_AML_CHECK,
  PaymentOrderV2StateEnum.AML_CHECK_FAILED,
]

export const MarkAmlApprovedAction: ActionMenuItem = ({ paymentOrder, onSuccess }) => {
  const { mutate, isLoading } = useMarkPaymentOrderAmlApproved()

  return (
    <MenuItem
      sx={{ display: 'flex', gap: '0.5rem' }}
      disabled={MarkAmlApprovedAction.disabled(paymentOrder) || isLoading}
      onClick={() => {
        if (window.confirm('Are you sure you want to mark the AML check as approved?')) {
          mutate(paymentOrder.id, { onSuccess })
        }
      }}
    >
      <ListItemIcon>{isLoading ? <CircularProgress size="22px" /> : <VerifiedUserIcon fontSize="small" />}</ListItemIcon>
      <ListItemText>Mark AML check approved</ListItemText>
    </MenuItem>
  )
}

MarkAmlApprovedAction.disabled = (paymentOrder) => !AML_APPROVABLE_STATES.includes(paymentOrder.state)
